import { render, staticRenderFns } from "./RequestFundsBusiness.vue?vue&type=template&id=5215f012&scoped=true"
import script from "./RequestFundsBusiness.vue?vue&type=script&lang=js"
export * from "./RequestFundsBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5215f012",
  null
  
)

export default component.exports